import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  CircularProgress,
  IconButton,
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { toast } from "react-toastify";
import { addAdmin } from "../../apis/apisList/adminApi";
const AddAdminModal = (props) => {
  const { open, onClose, fetchTrigger, setFetchTrigger } = props;
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    // Full Name
    if (!formData.fullName || formData.fullName.trim() === "") {
      newErrors.fullName = "Full name is required.";
    }

    // Email
    if (!formData.email || formData.email.trim() === "") {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    // Password
    if (!formData.password || formData.password.trim() === "") {
      newErrors.password = "Password is required.";
    }
    // else
    // if (formData.password.length < 10) {
    //   newErrors.password = "Password must be at least 6 characters.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        let sendData = {
          ...formData,
        };
        addAdmin(sendData).then((res) => {
          if (res?.success) {
            toast.success(res?.message);
            onClose();
            setFormData({});
            setFetchTrigger(!fetchTrigger);
          } else {
            toast.error(res?.message);
          }
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
      } catch (error) {
        toast.error("Something went wrong.");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <DialogTitle id="alert-dialog-title">Add Admin</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Name"
            value={formData.fullName}
            onChange={(e) =>
              setFormData({
                ...formData,
                fullName: e.target.value,
              })
            }
            error={!!errors.fullName}
            helperText={errors.fullName}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Email"
            value={formData.email}
            onChange={(e) =>
              setFormData({
                ...formData,
                email: e.target.value,
              })
            }
            error={!!errors.email}
            helperText={errors.email}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={(e) =>
              setFormData({
                ...formData,
                password: e.target.value,
              })
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!!errors.password}
            helperText={errors.password}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={false}>
            Cancel
          </Button>
          <Button
            type="submit"
            color="warning"
            variant="contained"
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddAdminModal;
